/* eslint-disable react-hooks/exhaustive-deps */
import {
  ApartmentOutlined,
  DeploymentUnitOutlined,
  EnvironmentOutlined,
  FlagOutlined,
} from '@ant-design/icons';
import { connect } from "react-redux";
import { expandIcon } from "datastake-daf/dist/components";
import { Table, List, Tag, Button, Typography } from 'antd';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Frame from '../frame';
import Style from './style';
import { filtersConfig } from './helper';
import EmptyState from '../empty-state';
import { Link } from 'react-router-dom';
import CustomProgressBar from './custom-progress-bar';
import { useModule } from '../../../../../../../helpers/user';
import { usePopOverHelper } from '../../../../../../../helpers/Charts';
import { actions } from '../../../../../../../store/reducers/dashboard';
import { camelCaseToTitle } from '../../../../../../../helpers/StringHelper';
import TablePagination from '../../../../../../../components/Table/pagination';
import { getLocales } from '../../../../../../../components/Table/newTable';

const { Text } = Typography;

export const Animated = ({ children, isActive, maxHeight: defaultMaxHeight, className }) => {
  const ref = useRef(null);
  const [maxHeight, setMaxHeight] = useState(defaultMaxHeight || 0);

  useEffect(() => {
    if (ref) {
      if (isActive) {
        setMaxHeight(defaultMaxHeight || ref.current.scrollHeight);
      } else {
        setMaxHeight(0);
      }
    }
  }, [isActive]);

  return (
    <div className={formatClassname([className, "expandedrow"])} ref={ref} style={{ maxHeight }}>
      {children}
    </div>
  );
}

const getSubject = (record) => {
  if (record.subject === 'location') {
    if (record.type === 'Mine Site') {
      return 'scl';
    }
    if (record.type === 'Village') {
      return 'village';
    }
  }
  return record.subject;
}

const getView = (record) => {
  if (record.subject === 'location' && record.type === 'Mine Site') {
    return 'analysis';
  }
  return 'view';
}

const Tasks = ({
  authentication: { user },
  t = (t) => t,
  siderHeight = 0,
  data = null,
  PmeDashboardGetWithFilters,
  language,
  selectedProject,
  valToResetFilters,
}) => {
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [expandedRows, setExpandedRows] = useState([]);
  const [frameActions, setFrameActions] = useState(null);
  const [currentFilters, setCurrentFilters] = useState(null);
  const { mod } = useModule();
  const { renderPopOver } = usePopOverHelper();
  const [initLoaded, setInitLoaded] = useState(false);
  const [sourceData, setSourceData] = useState({
    initialMapDone: false,
    data: [],
  });
  const loadingKeys = useRef({});

  const tableHeight = useMemo(() => siderHeight - 180, [siderHeight]);

  const columns = useMemo(() =>
    [
      {
        title: t('Name'),
        dataIndex: 'name',
        key: 'name',
        sort: true,
        sorter: () => 0 + 0,
        ellipsis: true,
        render: (name, record) => (
          <Link target="_blank" rel="noopener noreferrer" to={`/app/${mod}/${getView(record)}/${getSubject(record)}/${record.id}`}>
            <Text
              style={{ maxWidth: 250 }}
              ellipsis={{ tooltip: name }}
              className="ellipsis-span name-span text-light-blue"
            >
              {name}
            </Text>
          </Link>
        ),
        width: 300,
      },
      {
        title: t('Dashboard::Subject'),
        dataIndex: 'subject',
        key: 'subject',
        ellipsis: true,
        render: (subject) => renderPopOver(t(`Dashboard::${camelCaseToTitle(subject)}`)),
      },
      {
        title: t('Type'),
        dataIndex: 'type',
        key: 'type',
        ellipsis: true,
        render: (type) => renderPopOver(t(`Dashboard::${type}`)),
      },
      {
        title: t('Message'),
        dataIndex: 'message',
        key: 'message',
        ellipsis: true,
        render: (message, item) => {
          const missingTasks = item.subTasks.filter((i) => {
            switch (i.outcome.outcomeType) {
              case 'default':
                return i.outcome.outcome === 'missing';
              case 'percentage':
                return i.outcome.outcome !== 100;
              case 'completion':
                const splitted = i.outcome.outcome.split('/');
                return splitted[0] !== splitted[1];
              default:
            }
            return false;
          });
          const content = message > 0 && item.progress !== 100 ?
            <span>
              <span
                className="tasks-span text-light-blue"
                onClick={() => {
                  const iconOne = document.querySelector(`.show-row-${item.key}`);
                  const iconTwo = document.querySelector(`.hide-row-${item.key}`);
                  if (iconOne) {
                    iconOne.click();
                  } else if (iconTwo) {
                    iconTwo.click();
                  }
                }}
              >
                {missingTasks.length} {t('KeyTasks::pending')}
              </span>
              {' '}
            </span>
            : <span>{t('Essential information is provided')}</span>;
          return renderPopOver(content);
        },
      },
      {
        title: t('Dashboard::Progress'),
        dataIndex: 'progress',
        key: 'progress',
        sorter: () => 0 + 0,
        render: (progress, row) => row.subTasks.length === 0 ? t('There are no tasks') : <CustomProgressBar percent={progress} />,
        width: 120,
      },
    ], [t]);

  const setLoading = (val) => frameActions?.loading(val);

  useEffect(() => {
    if (data) {
      setTotal(data.total);
      setSourceData({
        initialMapDone: true,
        data: data.records.map((d, i) => ({
          key: i,
          name: d.name,
          subject: d.subject,
          type: d.type === 'riskMitigationMeasures' ? 'Corrective action' : camelCaseToTitle(d.type),
          subTasks: [...d.subTasks],
          message: d.subTasks.filter((d) => !d.done).length,
          progress: d.progress || 0,
          id: d.id,
        })),
      });
    } else {
      // setTotal(0);
      setSourceData({
        initialMapDone: false,
        data: [],
      });
    }
  }, [data]);

  useEffect(() => {
    if (frameActions) {
      if (data) {
        frameActions.loading(false);
      } else {
        frameActions.loading(true);
      }
    }
  }, [data, frameActions]);

  const renderRow = useCallback((record) => {
    const isActive = expandedRows.includes(record.key);
    const outcome = ({ outcome: item }) => {
      switch (item.outcomeType) {
        case 'default':
          return (
            <div>
              <Tag style={{ width: 100, textAlign: 'center' }} color={item.outcome === 'missing' ? 'error' : 'green'}>
                {t(`KeyTasks::${item.outcome}`)}
              </Tag>
            </div>
          );
        case 'completion':
          const data = item.outcome.split('/');
          return (
            <span>
              <span className="text-light-blue">{data[0]}</span>
              /
              {data[1]}
            </span>
          );
        case 'percentage':
          return <CustomProgressBar percent={item.outcome || 0} />
        case 'number':
          return <span className="text-light-blue">{item.outcome}</span>
        default:
          return null;
      }
    };

    return (
      <Animated isActive={isActive}>
        <List
          size="small"
          header={null}
          footer={null}
          bordered
          dataSource={record.subTasks}
          renderItem={item => {
            let action = item.action;
            if (item.authorId !== user?.company?.id) {
              action = action.replace(/\/edit\//, '/view/');
            }

            if (selectedProject !== 'myOwnData') {
              action = action.replace(/(\/edit\/|\/view\/)/, '/view/');
            }

            return <List.Item>
              <div className="expanded-container">
                <div className="main">
                  <Link to={`/app/${mod}${action}`} target="_blank">
                    {item.label}
                  </Link>
                </div>
                {outcome(item)}
              </div>
            </List.Item>
          }}
        />
      </Animated>
    );
  }, [expandedRows]);

  useEffect(() => {
    if (selectedProject && language && frameActions) {
      frameActions.resetFilters();
      frameActions.setClearFiltersVisibility(false);
      setCurrentFilters({});
    }
    setPage(1);
  }, [valToResetFilters, selectedProject]);

  useEffect(() => {
    const { sort, ...filters } = currentFilters || {};

    PmeDashboardGetWithFilters({
      noReset: true,
      setLoading,
      widget: 'tasks',
      filters,
      sort,
      pagination: {
        page: 1,
        perPage: 8,
      },
    });
    setPage(1);
    if (!initLoaded) {
      setInitLoaded(true);
    }
  }, [currentFilters, PmeDashboardGetWithFilters, language])

  const canGoNext = useMemo(() => {
    if (total === 0) {
      return false;
    }

    const pages = Math.ceil(total / 8);
    if (page !== pages) {
      return true;
    }

    return false;
  }, [page, total]);

  const canGoPrev = useMemo(() => page !== 1, [page]);

  const goNext = () => {
    const newPage = page + 1;
    const cfg = {
      widget: 'tasks',
      pagination: {
        page: newPage,
        perPage: 8,
      },
      noReset: true,
      setLoading,
    }
    if (currentFilters) {
      Object.assign(cfg, { filters: currentFilters });
    }
    PmeDashboardGetWithFilters(cfg, (success) => {
      if (success) {
        setPage(newPage);
      }
    });
  };

  const goPrev = () => {
    const newPage = page - 1;
    const cfg = {
      widget: 'tasks',
      pagination: {
        page: newPage,
        perPage: 8,
      },
      noReset: true,
      setLoading,
    }
    if (currentFilters) {
      Object.assign(cfg, { filters: currentFilters });
    }
    PmeDashboardGetWithFilters(cfg, (success) => {
      if (success) {
        setPage(newPage);
      }
    });
  };

  return <Frame
    title={t('Dashboard::Key Tasks')}
    filters={filtersConfig}
    onInit={actions => setFrameActions(actions)}
    borderedHeader={false}
    onFilterChange={(filters, outActions) => {
      if (Object.values(filters).length > 0) {
        outActions.setClearFiltersVisibility(true);
        setCurrentFilters((prev) => ({ sort: prev?.sort, ...filters }));
        setPage(1);
      }
    }}
    onClearFilters={() => {
      frameActions.setClearFiltersVisibility(false);
      setCurrentFilters(null);
      setPage(1);
    }}>
    <Style className={sourceData.data.length > 0 ? 'has-data' : 'no-data'}>
      {sourceData.initialMapDone && sourceData.data.length === 0 ? (
        <EmptyState buttonMinWidth250 imageUrl="/assets/images/dashboard/empty_tasks.svg" mainSectionCentered>
          <h1>{t('You have no activity to display here')}...</h1>
          <p>{t('Start with identifying a subject')}</p>
          <div className="btn-group">
            <Link to={`/app/${mod}/locations`} style={{ width: 300 }}>
              <Button className="btn-icon" icon={<EnvironmentOutlined />}>
                {t('Assess a Location')}
              </Button>
            </Link>
            <Link to={`/app/${mod}/events`}>
              <Button className="btn-icon" icon={<FlagOutlined />}>
                {t('Record an event')}
              </Button>
            </Link>
            <Link to={`/app/${mod}/stakeholders`}>
              <Button className="btn-icon" icon={<DeploymentUnitOutlined />}>
                {t('Identify a Stakeholder')}
              </Button>
            </Link>
            <Link to={`/app/${mod}/lir`}>
              <Button className="btn-icon" icon={<ApartmentOutlined />}>
                {t('Add a Local Information Relay')}
              </Button>
            </Link>
          </div>
        </EmptyState>
      ) : (
        <div className='daf-table-wrapper'>
          <Table
            locale={getLocales(t)}
            style={{ height: tableHeight - 10 }}
            size="small"
            columns={columns}
            expandable={{
              expandedRowRender: renderRow,
              rowExpandable: (record) => record.subTasks.length !== 0,
            }}
            onRow={({ key }) => ({
              className: formatClassname([
                key % 2 !== 0 && 'even-row',
                expandedRows.includes(key) && 'expanded-row',
              ])
            })}
            scroll={{ y: tableHeight - 60 }}
            onExpand={(expanded, { key }) => {
              if (expanded) {
                setExpandedRows((prev) => [...prev, key]);
              } else {
                setExpandedRows((prev) => prev.filter((p) => p !== key));
              }
            }}
            expandIcon={(props) => expandIcon({
              ...props,
              arrows: true,
              toggledKeys: expandedRows,
              setToggledKeys: setExpandedRows,
              loadingKeys,
            })}
            pagination={false}
            onChange={(p, filters, sort) => {
              if (sort) {
                const { columnKey, order } = sort;
                if ((filters?.sort?.by !== columnKey || filters?.sort?.dir !== order)) {
                  setCurrentFilters((prev) => ({ ...prev, sort: { by: columnKey, dir: order } }));
                }

              } else if (filters.sort) {
                setCurrentFilters((prev) => ({ ...prev, sort: undefined }));
              }
            }}
            dataSource={sourceData.data}
          />
          <TablePagination
            t={t}
            page={page}
            totalPages={total}
            goPrev={goPrev}
            goNext={goNext}
            canGoNext={canGoNext}
            canGoPrev={canGoPrev}
            totalItems={total}
            doTotalItems
            perPage={8}
          />
        </div>
      )}

    </Style>
  </Frame >;
}

export default connect(({ authentication }) => ({ authentication }), actions)(Tasks);
